import { Entity, Type } from "@jobilla/entity";
import { Money } from "./money";

export class OrderUser extends Entity {
  public userId!: number;

  @Type(Money)
  public amount!: Money;
}
